export default {
  "b2b.message.empty.items": "No records found",
  "b2b.components.not-found": "We don't have this here, try something else"
};
